export default __webpack_public_path__ + "static/media/brain_stem_mask.6dc9840f.png";